import { useAPM } from '@interhyp/platform-apm';
import { useEffect, useRef } from 'react';

/**
 * Capture the given error once
 * @param errorMsg
 */
export function useAPMErrorOnce(errorMsg: Error | string | undefined): void {
  const apm = useAPM();

  // This checks if the error was already captured.
  // Otherwise, every error would occur twice in APM because of the double execution of hooks in React Strict Mode
  const alreadyCaptured = useRef<boolean>(false);

  useEffect(() => {
    if (!errorMsg || alreadyCaptured.current) {
      return;
    }

    apm.captureError(errorMsg);

    return () => {
      alreadyCaptured.current = true;
    };
  }, [alreadyCaptured, apm, errorMsg]);
}
